const UitkTypeSizeMap = [
  [100, "uitk-type-100"],
  [200, "uitk-type-200"],
  [300, "uitk-type-300"],
  [400, "uitk-type-400"],
  [500, "uitk-type-500"],
  [600, "uitk-type-600"],
  [700, "uitk-type-700"],
  [800, "uitk-type-800"],
  [900, "uitk-type-900"]
];
export const UitkTypeSizes = new Map(UitkTypeSizeMap);
const UitkTypeWeightMap = [
  ["regular", "uitk-type-regular"],
  ["medium", "uitk-type-medium"],
  ["bold", "uitk-type-bold"]
];
export const UitkTypeWeights = new Map(UitkTypeWeightMap);
const UitkTypeAlignmentMap = [
  ["left", "uitk-type-start"],
  ["right", "uitk-type-end"],
  ["center", "uitk-type-center"]
];
export const UitkTypeAlignments = new Map(UitkTypeAlignmentMap);
const UitkTypeOverflowMap = [
  ["wrap", "overflow-wrap"],
  ["truncate", "truncate"],
  ["truncate-2-lines", "truncate-lines-2"],
  ["truncate-3-lines", "truncate-lines-3"]
];
export const UitkTypeOverflows = new Map(UitkTypeOverflowMap);
const UitkTypeHyphensMap = [
  ["none", "hyphens-none"],
  ["manual", "hyphens-manual"],
  ["auto", "hyphens-auto"]
];
export const UitkTypeHyphens = new Map(UitkTypeHyphensMap);
const UitkHeadingSizeMap = [
  [1, "uitk-heading-1"],
  [2, "uitk-heading-2"],
  [3, "uitk-heading-3"],
  [4, "uitk-heading-4"],
  [5, "uitk-heading-5"],
  [6, "uitk-heading-6"],
  [7, "uitk-heading-7"],
  [8, "uitk-heading-8"]
];
export const UitkHeadingSizes = new Map(UitkHeadingSizeMap);
const UitkParagraphSizeMap = [
  [1, "uitk-paragraph-1"],
  [2, "uitk-paragraph-2"],
  [3, "uitk-paragraph-3"]
];
export const UitkParagraphSizes = new Map(UitkParagraphSizeMap);
const UitkTypeMarginMap = [
  ["half", "uitk-text-spacing-half"],
  ["one", "uitk-text-spacing-one"],
  ["two", "uitk-text-spacing-two"],
  ["three", "uitk-text-spacing-three"],
  ["four", "uitk-text-spacing-four"],
  ["six", "uitk-text-spacing-six"]
];
export const UitkTypeMargins = new Map(UitkTypeMarginMap);
const UitkHeadingTagMap = [
  ["h1", "h1"],
  ["h2", "h2"],
  ["h3", "h3"],
  ["h4", "h4"],
  ["h5", "h5"],
  ["h6", "h6"]
];
export const UitkHeadingTags = new Map(UitkHeadingTagMap);
const UitkSubHeadingTagMap = [...UitkHeadingTagMap, ["p", "p"]];
export const UitkSubHeadingTags = new Map(UitkSubHeadingTagMap);
const UitkTextThemeMap = [
  ["default", ""],
  ["positive", "uitk-text-positive-theme"],
  ["negative", "uitk-text-negative-theme"],
  ["warning", "uitk-text-warning-theme"],
  ["informative", "uitk-text-informative-theme"]
];
export const UitkTextThemes = new Map(UitkTextThemeMap);
const UitkTypeWhiteSpaceMap = [
  ["normal", "uitk-text-white-space-normal"],
  ["nowrap", "uitk-text-white-space-nowrap"],
  ["pre", "uitk-text-white-space-pre"],
  ["pre-wrap", "uitk-text-white-space-pre-wrap"],
  ["pre-line", "uitk-text-white-space-pre-line"],
  ["break-spaces", "uitk-text-white-space-break-spaces"]
];
export const UitkTypeWhiteSpaces = new Map(UitkTypeWhiteSpaceMap);
const UitkTextInlineTagsMap = [
  ["b", "b"],
  ["em", "em"],
  ["s", "s"],
  ["small", "small"],
  ["i", "i"],
  ["strong", "strong"],
  ["q", "q"]
];
export const UitkTextInlineTags = new Map(UitkTextInlineTagsMap);
